export const urlRegex =
  /(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+/i

export const emailRegex = /[^\s@]+@[^\s@]+\.[^\s@]+/i

export const facebookRegex = /facebook|fb/i

export const messengerRegex = /messenger/i

export const atRegex = /@|at|\[at\]/i

export const successiveNumberWordsRegex =
  /((un|deux|trois|quatre|cinq|six|sept|huit|neuf)\s*){2,}/i

export const successiveNumbersRegex = /([0-9]\s*){2,}/i
